import { useSelector } from 'react-redux';

import { userAdminGroup } from 'commons/types/userGroup';
import { selectUser } from 'redux-stores/features/authSlice';

export function CheckUserRoles(
  rolesGroup: string[],
  isStrictRole?: boolean,
): boolean {
  const user = useSelector(selectUser);
  const userRoles = user.roles;
  const allRoles = isStrictRole
    ? rolesGroup
    : [...rolesGroup, ...userAdminGroup];
  return userRoles.some((role) => allRoles.includes(role));
}
